import { render } from "./TodayDiagnosisBilling.vue?vue&type=template&id=aa0482a4&scoped=true"
import script from "./TodayDiagnosisBilling.vue?vue&type=script&lang=js"
export * from "./TodayDiagnosisBilling.vue?vue&type=script&lang=js"

import "./TodayDiagnosisBilling.vue?vue&type=style&index=0&id=aa0482a4&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0482a4"]])

export default __exports__